import type { SchemaInput } from './schema-input.js';
import { isBoolean, isSchemaRecord } from './runtime-values.js';

export const PRO_PLAN = 'pro';
export const SERVICE_AREA_WIDGET_PLAN = 'service_area_widget';

export interface ProductAccess {
  pro: boolean;
  serviceAreaWidget: boolean;
}

export function hasProAccess(access: ProductAccess | null | undefined): boolean {
  return access?.pro === true;
}

export function hasServiceAreaWidgetAccess(access: ProductAccess | null | undefined): boolean {
  return access?.serviceAreaWidget === true;
}

export function productAccessFromUser(user: SchemaInput): ProductAccess | null {
  if (!isSchemaRecord(user) || !isSchemaRecord(user.access)) return null;
  if (!isBoolean(user.access.pro) || !isBoolean(user.access.serviceAreaWidget)) return null;
  return {
    pro: user.access.pro,
    serviceAreaWidget: user.access.serviceAreaWidget,
  };
}

export function planForCheckoutFeature(feature: string | null | undefined): string {
  return feature === SERVICE_AREA_WIDGET_PLAN ? SERVICE_AREA_WIDGET_PLAN : PRO_PLAN;
}
